import * as React from 'react';
import { Component } from 'react';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import { StyleSheet, css } from '@coursera/coursera-ui';

import Submit from 'bundles/authentication/components/Submit';
import Alert from 'bundles/authentication/shared/Alert';
import Form from 'bundles/authentication/shared/Form';
import TextInput from 'bundles/authentication/shared/TextInput';
// FIXME: existing import/no-cycle violations are excused to prevent seeing errors when modifying other parts of the same file; please fix it carefully
// eslint-disable-next-line import/no-cycle
import { MODES } from 'bundles/authentication/shared/components/authentication-modal/AuthenticationContent';
import LinkButton from 'bundles/authentication/shared/components/authentication-modal/LinkButton';
import withOrganizationSSO from 'bundles/authentication/shared/components/authentication-modal/OrganizationSSO/withOrganizationSSO';

import _t from 'i18n!nls/authentication';

type Props = {
  error?: string;
  navigate: (path: MODES, options?: $TSFixMe) => void;
  onSubmit: ({ url }: { url: string }) => void;
  referrer?: MODES;
  hideBackToLink?: boolean;
};

const styles = StyleSheet.create({
  container: {
    display: 'grid',
    gridGap: '24px',
    gridTemplateColumns: '1fr',
    margin: '0 auto',
    maxWidth: '396px',
    padding: '32px 16px',
  },
  form: {
    display: 'grid',
    gridGap: '12px',
    gridTemplateColumns: '1fr',
  },
  navigation: {
    margin: '0',
    textAlign: 'center',
  },
  section: {
    ':nth-child(1)': {
      '-ms-grid-row': '1',
    },
    ':nth-child(2)': {
      '-ms-grid-row': '2',
    },
    ':nth-child(3)': {
      '-ms-grid-row': '3',
    },
  },
  title: {
    color: '#1F1F1F',
    fontFamily: 'OpenSans',
    fontSize: '24px',
    lineHeight: '30px',
    margin: '0',
    textAlign: 'center',
    '@media (min-width: 600px)': {
      fontSize: '34px',
      lineHeight: '42px',
    },
  },
  submit: {
    marginTop: '12px',
  },
  link: {
    textDecoration: 'underline',
  },
});

export class OrganizationSSO extends Component<Props> {
  state = {
    isButtonDisabled: true,
  };

  navigateBack = () => {
    const { navigate, referrer } = this.props;

    return navigate(referrer || MODES.LOGIN);
  };

  render() {
    const { error, onSubmit, referrer, hideBackToLink = false } = this.props;

    const title =
      referrer === MODES.SIGNUP ? _t('Sign up with your organization') : _t('Log in with your organization');
    const navigateTo = referrer === MODES.SIGNUP ? _t('Sign Up') : _t('Log in');

    return (
      <section {...css('rc-OrganizationSSO', styles.container)}>
        <header {...css(styles.section)}>
          <h1 {...css(styles.title)}>{title}</h1>
        </header>
        <Form
          {...css(styles.form, styles.section)}
          // @ts-expect-error FIXME result of fixing typing on coursera-ui aphrodite exports in PR#45351
          onSubmit={onSubmit}
          onInput={(e) => {
            const formRef = e.currentTarget;
            this.setState({ isButtonDisabled: !formRef.checkValidity() });
          }}
        >
          {error && (
            <Alert {...css(styles.section)} type="error">
              {error}
            </Alert>
          )}
          <TextInput
            {...css(styles.section)}
            label={_t('Enter your organization URL')}
            name="url"
            hint={
              <a
                href="https://learner.coursera.help/hc/articles/115004807263"
                rel="noopener noreferrer"
                target="_blank"
                {...css(styles.link)}
              >
                {_t('Help')}
              </a>
            }
            placeholder={_t('(ex: company.com or company.org)')}
            autoComplete="organization"
            required={true}
          />
          <Submit disabled={this.state.isButtonDisabled} {...css(styles.submit, styles.section)}>
            Continue
          </Submit>
        </Form>

        {!hideBackToLink && (
          <p {...css(styles.navigation, styles.section)}>
            <FormattedMessage
              message={_t('{backTo} {backToLink}.')}
              backTo={<span aria-hidden="true">{_t('Back to')}</span>}
              backToLink={
                <LinkButton onClick={this.navigateBack} type="button">
                  {navigateTo}
                </LinkButton>
              }
            />
          </p>
        )}
      </section>
    );
  }
}

export default withOrganizationSSO(OrganizationSSO);
